// Vite plugin để thêm version vào các file JS/CSS trong HTML output
import type { Plugin } from 'vite';
import { readFileSync } from 'fs';
import { join } from 'path';

export function versionPlugin(): Plugin {
    return {
        name: 'version-cache-bust',
        enforce: 'post',
        generateBundle(options, bundle) {
            // Plugin này sẽ chạy trong quá trình build
            // Version sẽ được thêm vào thông qua Nuxt hooks
        },
        transformIndexHtml(html) {
            try {
                // Đọc version từ version.json
                const versionPath = join(process.cwd(), 'public', 'version.json');
                const versionData = JSON.parse(readFileSync(versionPath, 'utf-8'));
                const version = versionData.version || Date.now().toString();
                
                // Thêm version query parameter vào tất cả các script tags
                html = html.replace(
                    /(<script[^>]*src=["']([^"']+)["'][^>]*>)/gi,
                    (match: string, fullTag: string, src: string) => {
                        if (src && !src.includes('?v=') && !src.startsWith('http://') && !src.startsWith('https://') && !src.startsWith('//')) {
                            const separator = src.includes('?') ? '&' : '?';
                            return fullTag.replace(src, `${src}${separator}v=${version}`);
                        }
                        return match;
                    }
                );
                
                // Thêm version query parameter vào tất cả các link tags (CSS)
                html = html.replace(
                    /(<link[^>]*href=["']([^"']+)["'][^>]*rel=["']stylesheet["'][^>]*>)/gi,
                    (match: string, fullTag: string, href: string) => {
                        if (href && !href.includes('?v=') && !href.startsWith('http://') && !href.startsWith('https://') && !href.startsWith('//')) {
                            const separator = href.includes('?') ? '&' : '?';
                            return fullTag.replace(href, `${href}${separator}v=${version}`);
                        }
                        return match;
                    }
                );
                
                return html;
            } catch (error) {
                console.warn('Không thể thêm version vào HTML:', error);
                return html;
            }
        }
    };
}

